<div class="layout-beta">
  <nz-layout>
    <div #content>
      <nz-header>
        <div class="layout-beta__header">
          <a class="layout-beta__logo" [routerLink]="['/']">
            <img
              src="assets/icons/key_7_logo.svg"
              alt="Logo"
              class="layout-beta__logo-image"
            />
          </a>

          <nz-space>
            <!-- User -->
            <button nz-button nzType="primary" ngClass="zeta" class="layout-beta__gamepad-button">
              <span nz-icon nzType="ng-zorro:gamepad" nzTheme="outline"></span>
              <div class="notification-badge">4</div>
            </button>
          </nz-space>
        </div>
      </nz-header>

      <nz-content class="content-container">
        <router-outlet></router-outlet>
      </nz-content>
      <nz-footer class="footer-container">
        <app-footer></app-footer>
      </nz-footer>
    </div>
  </nz-layout>

  <nz-drawer
    [nzVisible]="isSideMenuDrawerVisible"
    nzPlacement="right"
    [nzClosable]="false"
    [nzWrapClassName]="'side-menu'"
  >
    <h1>Hello World</h1>
  </nz-drawer>


  <div class="layout-alpha__hexagon"></div>

</div>
